import(/* webpackMode: "eager", webpackExports: ["CollapsibleSidebar"] */ "/vercel/path0/apps/web/components/collapsible-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FolderProvider"] */ "/vercel/path0/apps/web/context/FolderContext.tsx");
